import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteRole = async (roleName: string) => {
  await systemEngineEnvironment.execute(`drop role if exists "${roleName}"`);
};
